<template>
  <!-- Table Container Card -->
  <b-card :title="$t('operation.users')">
    <!-- Delete Model -->
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteUser" />

    <!-- Edit modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      :ok-title="$t('common.ok')"
      centered
      size="lg"
      :title="`${$t('common.edit')} ${$t('operation.user')}`"
      @ok="updateItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('operation.email')">
              <b-form-input
                v-model="EditForm.email"
                :placeholder="$t('operation.email')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('warehouse.department')">
              <AutoComplete
                :placeholder="`${$t('common.select')} ${$t(
                  'warehouse.department'
                )}`"
                v-model="EditForm.department_id"
                :serializer="(val) => val.id"
                param-query="search"
                endpoint="departments"
                text-title="name"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <div
              class="mt-2 mt-md-0 w-100 mx-1"
              v-for="(item, index) in userRols"
              :key="index"
            >
              <b-row>
                <b-col md="10" cols="12">
                  <AutoComplete
                    :label="$t('operation.roles')"
                    :placeholder="$t('operation.roles')"
                    v-model="userRols[index]"
                    :serializer="(val) => val.id"
                    param-query="search"
                    endpoint="role"
                    text-title="name"
                  />
                </b-col>

                <b-col
                  class="d-flex align-items-center w-full"
                  md="2"
                  cols="12"
                >
                  <b-button
                    class="mx-1 w-full"
                    variant="primary"
                    size="sm"
                    @click="addDoctor"
                    >+</b-button
                  >
                  <b-button
                    :disabled="index === 0"
                    size="sm"
                    variant="danger"
                    @click="removeDoctor(index)"
                    >X</b-button
                  >
                </b-col>
              </b-row>
            </div>
            <!-- <AutoComplete
              :label="$t('operation.roles')"
              :placeholder="`${$t('common.select')} ${$t('operation.role')}`"
              v-model="EditForm.role_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="role"
              text-title="name"
            /> -->
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <!-- add Page -->
    <div class="m-2"></div>
    <div class="m-2">
      <!-- Search -->
      <b-row>
        <b-col md="10">
          <b-form-group :label="$t('common.name')">
            <b-form-input
              v-model="filterData.name"
              :placeholder="$t('common.name')"
            />
          </b-form-group>
        </b-col>
        <b-col
          md="2"
          class="d-flex align-items-center justify-content-start mt-1"
        >
          <b-button variant="primary" @click="index()">
            {{ $t("common.search") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-row class="my-2">
      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-between mb-1 mb-md-0"
      >
        <h3>{{ $t("common.table") }} {{ $t("operation.users") }}</h3>
        <b-button
          @click="$router.push({ name: 'add-users' })"
          variant="primary"
          v-if="$store.state.app.permissions.includes('store-user')"
        >
          {{ $t("common.add") }} {{ $t("operation.user") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- Data Table  -->
    <b-table
      :items="usersData"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="position-relative"
      v-if="!loading"
    >
      <!-- Column: Id -->
      <template #cell(id)="data">
        <b-link
          :to="{ name: 'city', params: { id: data.item.id } }"
          class="font-weight-bold"
        >
          {{ data.item.id }}
        </b-link>
      </template>

      <!-- Column: Username -->
      <template #cell(Username)="data">
        <span class="text-nowrap">
          {{ data.item.username }}
        </span>
      </template>

      <!-- Column: Phone -->
      <template #cell(Phone)="data">
        <span class="text-nowrap">
          {{ data.item.phone }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-row class="text-nowrap">
          <b-button
            pill
            variant="outline-primary"
            class="mx-1"
            size="sm"
            @click="
              $router.push({
                name: 'users-preview',
                params: { id: data.item.id },
              })
            "
          >
            {{ $t("operation.permissions") }}
          </b-button>
          <ActionsButtons
            deletePerm="delete-user"
            editPerm="update-user"
            @editToggle="show(data.item)"
            @deleteToggle="deleteModel(data.item)"
          />
        </b-row>
      </template>
    </b-table>
    <template v-if="loading">
      <div>
        <div class="d-flex justify-content-center mb-1">
          <b-spinner :label="$t('common.loading')" />
        </div>
      </div>
    </template>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted"
            >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
            {{ $t("operation.users") }}</span
          >
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
          @click="index()"
        >
          <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="take"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    AutoComplete,
    ActionsButtons,
    DeleteModal,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      tableColumns: [
        // { key: "Id", label: "#", sortable: true },
        { key: "name", label: this.$t("common.name"), sortable: true },
        { key: "email", label: this.$t("operation.email"), sortable: true },
        {
          key: "departments[0].name",
          label: this.$t("warehouse.department"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      EditForm: {
        name: "",
        email: "",
        role_id: "",
        department_id: null,
        _method: "PUT",
      },
      take: 10,
      loading: true,
      selected: "",
      totalInvoices: 0,
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      totalRows: "",
      page: 1,
      params: {
        form: {},
        path: "",
      },
      deleteForm: [],
      statusFilter: null,
      departmentList: [],
      jobTitleList: [],
      include: "department,jobTitle",
      usersData: "",
      filterData: {
        name: "",
      },
      userRols: [""],
    };
  },

  mounted() {
    this.index();
  },
  methods: {
    show(item) {
      this.EditForm.id = item.id;
      this.EditForm.name = item.name;
      this.EditForm.email = item.email;
      this.EditForm.department_id = item.departments[0]
        ? item.departments[0].id
        : null;
      this.userRols = item.roles.length
        ? item.roles.map((item) => item.pivot.role_id)
        : [""];

      this.$bvModal.show("modal-edit");
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    addDoctor() {
      this.userRols.push("");
    },

    removeDoctor(index) {
      if (index === 0) return;
      this.userRols.splice(index, 1);
    },

    async index() {
      this.loading = true;

      let url = `/user?take=${this.take}&page=${this.page}&sort=-id&include=roles,departments`;

      if (this.filterData.name) {
        url += `&filter[name]=${this.filterData.name}`;
      }

      await this.getList(url);
      this.totalRows = this.all_data.total;
      this.usersData = this.all_data.data;
      this.loading = false;
    },
    async asignRole() {
      this.userRols.roleIds = this.userRols;
      (this.params.form.roleIds = this.userRols),
        (this.params.path = `/assign-role-to/user/${this.EditForm.id}`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.index();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    updateItem() {
      if (this.userRols) {
        this.asignRole();
      }
      if (this.EditForm.name.title) {
        this.EditForm.name = this.EditForm.name.title;
      }
      if (this.EditForm.department_id == null) {
        delete this.EditForm.department_id;
      }
      (this.params.form = this.EditForm),
        (this.params.path = `/user/${this.EditForm.id}`),
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.index();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    deleteUser() {
      this.$store
        .dispatch("delete", `/user/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.name,
            },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
